<template>
  <div>
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
  @import "@/assets/css/app.scss";
  @import "@/assets/css/admin/common.scss";
</style>
<style>
  @import "https://www.audiotestkitchen.com/player/dist/css/atk-player.css";
  @import "https://atk-player.s3.amazonaws.com/dist/css/atk-mobile.css";
</style>
